module.exports = __webpack_public_path__ + "img/k-2-hover.f70cc944.png";